<script setup lang="ts">
import logoPath from '@/assets/logo.svg'

import ProgressSteps from '../components/ProgressSteps.vue'
import PageGegevens from './pages/PageIntroductie.vue'
import PageTypeInnovatie from './pages/PageProjectGegevens.vue'
import PageThemasStart from './pages/PageThemasStart.vue'
import PagePageThemasInstallatiearm from './pages/PageThemasInstallatiearm.vue'
import PageThemasMilieu from './pages/PageThemasMilieu.vue'
import PageThemasWaardebehoud from './pages/PageThemasWaardebehoud.vue'
import PageThemasUitbreiding from './pages/PageThemasUitbreiding.vue'
import PageEmailGegevens from './pages/PageEmailGegevens.vue'
import PageStart from './pages/PageStart.vue'
import PageEnd from './pages/PageEnd.vue'
// @ts-expect-error this module is not typed
import ClipLoader from 'vue-spinner/src/ClipLoader.vue'
import { ref } from 'vue'
import { useRegistrationStore } from '@/stores/registration'
import emailService from '@/services/emailService'

const sendingEmail = ref(false)
const page = ref(0)
const store = useRegistrationStore()
const sendResultSuccess = ref(false)

function navigateForward() {
  page.value++
  store.nextStep()
}

function navigateBack() {
  page.value--
  store.previousStep()
}

async function sendEmail(data: {
      email: string,
      ontvangerNaam: string,
      naam: string,
      opgave: string,
      adres: string,
      plaats: string,
      schoolType: string[],
      thema: string[]
    }) {
  store.nextStep()
  sendingEmail.value = true

  try {
    const result = await emailService.sendEmail(data)
    if (result && result.data == "SUCCESS") {
      sendResultSuccess.value = true
    }
  } catch (e) {
    console.log(e)
  }

  sendingEmail.value = false
  page.value = 9
}

function restart() {
  sendingEmail.value = false
  page.value = 0
}
</script>

<template>
  <main class="flex">
    <div class="bg-pohvBlue h-screen flex-1/3 bg-no-repeat bg-size-[90%] bg-bottom overflow-y-auto" :style="`background-image: url('${logoPath}')`">
      <ProgressSteps />
    </div>
    <div class="flex-2/3 h-full" :class="sendingEmail && 'm-auto'">
      <div v-if="!sendingEmail" class="m-auto">
        <PageStart v-if="page == 0" :showLeftButton="false" @navigateForward="navigateForward" @start="navigateForward" />
        <PageGegevens v-if="page == 1" @navigateBack="navigateBack" @navigateForward="navigateForward" />
        <PageTypeInnovatie v-if="page == 2" @navigateBack="navigateBack" @navigateForward="navigateForward" />
        <PageThemasStart v-if="page == 3" @navigateBack="navigateBack" @navigateForward="navigateForward" />
        <PagePageThemasInstallatiearm v-if="page == 4" @navigateBack="navigateBack" @navigateForward="navigateForward"></PagePageThemasInstallatiearm>
        <PageThemasMilieu v-if="page == 5" @navigateBack="navigateBack" @navigateForward="navigateForward"></PageThemasMilieu>
        <PageThemasWaardebehoud v-if="page == 6" @navigateBack="navigateBack" @navigateForward="navigateForward"></PageThemasWaardebehoud>
        <PageThemasUitbreiding v-if="page == 7" @navigateBack="navigateBack" @navigateForward="navigateForward" />
        <PageEmailGegevens v-if="page == 8" :showRightButton="false" @navigateBack="navigateBack" @send-email="sendEmail"></PageEmailGegevens>
        <PageEnd v-if="page == 9" @restart="restart" :success="sendResultSuccess" />
      </div>
      <div v-if="sendingEmail" class="flex flex-col gap-4">
        <ClipLoader :color="'#007FAD'" />
        <div class="text-center text-xl">Email Verzenden...</div>
      </div>
    </div>
  </main>
</template>
